import { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const TimeRangePicker = ({ value, onChange }) => {

    // 使用固定基准日期处理时间
    const baseDate = new Date(1970, 0, 1);

    // 时间转换函数（带错误处理）
    const parseTime = (timeStr) => {
        try {
            if (!timeStr) return null;
            const [hours, minutes] = timeStr.split(':').map(Number);
            const date = new Date(baseDate);
            date.setHours(hours);
            date.setMinutes(minutes);
            return date;
        } catch (error) {
            console.error('时间解析错误:', error);
            return baseDate;
        }
    };

    // 同步父组件数据变化
    useEffect(() => {
        setStartTime(parseTime(value.start));
        setEndTime(parseTime(value.end));
    }, [value.start, value.end]);

    // 状态管理
    const [startTime, setStartTime] = useState(parseTime(value.start));
    const [endTime, setEndTime] = useState(parseTime(value.end));

    // 优化后的时间处理
    const handleTimeChange = (type, date) => {
        if (!date) return;

        // 创建新的时间对象（避免引用问题）
        const newDate = new Date(baseDate);
        newDate.setHours(date.getHours());
        newDate.setMinutes(date.getMinutes());

        const timeString = `${newDate.getHours().toString().padStart(2, '0')}:${newDate.getMinutes().toString().padStart(2, '0')}`;
        const newValue = {
            ...value,
            [type]: timeString
        };

        // 自动调整结束时间
        if (type === 'start' && endTime && newDate > endTime) {
            newValue.end = timeString;
            setEndTime(newDate);
        }

        // 更新本地状态
        type === 'start' ? setStartTime(newDate) : setEndTime(newDate);

        // 通知父组件
        onChange(newValue);
    };

    return (
        <div className="d-flex align-items-center gap-1">
            {/* Start time选择器 */}
            <DatePicker
                selected={startTime}
                onChange={(date) => handleTimeChange('start', date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Start time"
                dateFormat="HH:mm"  // 关键配置1
                timeFormat="HH:mm"  // 关键配置2
                placeholderText="Start time"
                customInput={
                    <input
                        className="form-control"
                        style={{ width: '110px' }}
                    />
                }
                popperClassName="time-picker-popper"
            />

            <span className="text-muted px-1">-</span>

            {/* End Time选择器 */}
            <DatePicker
                selected={endTime}
                onChange={(date) => handleTimeChange('end', date)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                minTime={startTime || new Date().setHours(0, 0)}
                maxTime={new Date().setHours(23, 59)}
                timeCaption="End Time"
                dateFormat="HH:mm"  // 关键配置1
                timeFormat="HH:mm"  // 关键配置2
                placeholderText="End Time"
                customInput={
                    <input
                        className="form-control"
                        style={{ width: '110px' }}
                        disabled={!startTime}
                    />
                }
                popperClassName="time-picker-popper"
            />
        </div>
    );
};

export default TimeRangePicker;